/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RingInputs */

const en_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ring`)
};

const es_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anillo`)
};

const fr_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bague`)
};

const de_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ring`)
};

const ja_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リング`)
};

const zh_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戒指`)
};

const ar_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خاتم`)
};

const id_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cincin`)
};

const it_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anello`)
};

const ru_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кольцо`)
};

const pt_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anel`)
};

const ko_val_ring = /** @type {(inputs: Val_RingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반지`)
};

/**
* | output |
* | --- |
* | "Ring" |
*
* @param {Val_RingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ring = /** @type {((inputs?: Val_RingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ring(inputs)
	if (locale === "es") return es_val_ring(inputs)
	if (locale === "fr") return fr_val_ring(inputs)
	if (locale === "de") return de_val_ring(inputs)
	if (locale === "ja") return ja_val_ring(inputs)
	if (locale === "zh") return zh_val_ring(inputs)
	if (locale === "ar") return ar_val_ring(inputs)
	if (locale === "id") return id_val_ring(inputs)
	if (locale === "it") return it_val_ring(inputs)
	if (locale === "ru") return ru_val_ring(inputs)
	if (locale === "pt") return pt_val_ring(inputs)
	return ko_val_ring(inputs)
});